<template>
  <div class="px-4 d-flex flex-column justify-start">
    <TokenUsagePanel
      class="mt-4"
      :key="updateTimestamp"
      :organizationId="organization._id"
    />

    <v-divider v-if="!isReadOnly" class="my-4" />

    <TokenAssignmentPanel
      v-if="!isReadOnly"
      :organization="organization"
      @handleTokensUpdated="handleTokensUpdated"
    />

    <v-divider class="my-4" />

    <div>
      <p class="font-weight-500 font-size-18 pa-0">
        {{ $t('ai_features.token_deposit_history.assignment_history') }}
      </p>
      <v-card outlined class="my-4">
        <TokenDepositHistoryTable
          :key="updateTimestamp"
          :organizationId="organization._id"
        />
      </v-card>
    </div>
  </div>
</template>
<script>
import TokenAssignmentPanel from './TokenAssignmentPanel.vue'
import TokenUsagePanel from '@/components/AIManagement/TokensUsagePanel.vue'
import TokenDepositHistoryTable from '@/components/AIManagement/TokenDepositsHistoryTable.vue'

export default {
  name: 'TokenManagement',

  components: {
    TokenAssignmentPanel,
    TokenUsagePanel,
    TokenDepositHistoryTable,
  },

  props: {
    organization: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      updateTimestamp: null,
    }
  },

  methods: {
    async handleTokensUpdated() {
      this.updateTimestamp = Date.now() // Update timestamp to trigger re-fetch
    },
  },
}
</script>
